import type { ActionReducer, MetaReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

import type { AppState } from './app-reducers';

export function createLocalStorageSyncReducer(encryptionService: {
  encrypt(value: string): string;
  decrypt(value: string | null): string | null;
}): MetaReducer<AppState> {
  return (reducer: ActionReducer<AppState>): ActionReducer<AppState> => {
    return (state, action) => {
      if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
        return reducer(state, action);
      }

      const ENCRYPTED_STORAGE: Storage = {
        get length(): number {
          return localStorage.length;
        },

        clear(): void {
          localStorage.clear();
        },

        key(index: number): string | null {
          return localStorage.key(index);
        },

        setItem(key: string, value: string): void {
          localStorage.setItem(key, encryptionService.encrypt(value));
        },

        getItem(key: string): string | null {
          const VALUE = localStorage.getItem(key);
          return VALUE ? encryptionService.decrypt(VALUE) : null;
        },

        removeItem(key: string): void {
          localStorage.removeItem(key);
        },
      };

      return localStorageSync({
        keys: ['web'],
        rehydrate: true,
        storage: ENCRYPTED_STORAGE,
      })(reducer)(state, action);
    };
  };
}
